import { render, staticRenderFns } from "./AgreementHeader.vue?vue&type=template&id=54ef7e8b&"
import script from "./AgreementHeader.vue?vue&type=script&lang=js&"
export * from "./AgreementHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports